/* eslint-disable react/destructuring-assignment */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/naming-convention */
import React, { useEffect, useState } from "react";
import { Field, Form, Formik } from "formik";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { useLocation, withRouter } from "react-router-dom";
import Cookies from "universal-cookie";
import * as Yup from "yup";
import { Col, Container, InputGroup, Row } from "react-bootstrap";
import menuBg from "../../assets/images/bg/menu/home.svg";
// images
import loginBg from "../../assets/images/bg/reset-password.svg";
import eye_visible from "../../assets/images/icons/eye_visible.svg";
import eye_Invisible from "../../assets/images/icons/eye_Invisible.svg";

// components
import Header from "../../components/header";
import MainMenu from "../../components/mainMenu";
import { resetPasswordAction } from "../forgetPassword/actions";
import email from "../../assets/images/icons/email2.svg";
import FooterBottom from "../../components/footerBottom";
import { regex } from "../../utils/regex";
import CustomButton from "../../components/Buttons/CustomButton";
import useReactRefresh from "../../hooks/useReactRefresh";

const validationSchema = Yup.object({
  email: Yup.string()
    .required("email Can not be empty")
    .email("email must be a valid email address")
    .matches(regex.email, "email must be a valid email address"),
  password: Yup.string()
    .required("Password can not be empty")
    .matches(regex.password, "Password must include minimum 8 characters with one uppercase, one special character and one numeric value."),
  reEnter_password: Yup.string()
    .required("confirm password can not be empty")
    .oneOf([Yup.ref("password"), null], "password dose not match"),
});
const cookie = new Cookies();

function ResetPassword(props) {
  const get_reset_email = cookie.get("forget_email");
  const [state, setState] = useState({
    show_pass: false,
    con_pass: false,
  });
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const [openMenu, setOpenMenu] = useState(false);
  const handleOpenMenu = () => {
    setOpenMenu(!openMenu);
  };
  const handleCloseMenuMenu = () => {
    setOpenMenu(false);
  };
  const initialState = {
    email: "",
    password: "",
    reEnter_password: "",
  };
  const handleSubmit = (values, actions) => {
    const data = {
      password: values.password,
      email: values.email ?? get_reset_email?.email,
      token: query.get("token"),
    };
    props.resetPasswordAction(data, actions, props.history);
  };
  useEffect(() => {
    const token = query.get("token");
    if (!token) {
      window.location.pathname = "/";
    }
  }, [query]);

  useReactRefresh();

  return (
    <>
      <Helmet>
        <title>Reset Password - Clarity Cooperative</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <MainMenu closeMenu={handleCloseMenuMenu} title="NAVIGATE" bgImage={menuBg} className={openMenu ? "active" : ""} />
      <Header openMenu={handleOpenMenu} className="headerStyleWhite" logoWhite />
      <div
        style={{
          background: `url(${loginBg}) no-repeat center center / cover`,
        }}
        className="d-none"
      >
        <Container className="py-3 py-sm-4 py-md-5">
          <Row className="justify-content-center">
            <Col md={10} lg={8} xl={6}>
              <Formik initialValues={initialState} onSubmit={handleSubmit} validationSchema={validationSchema}>
                {({ values, handleChange, handleBlur, touched, errors }) => {
                  return (
                    <Form className="loginForm">
                      <h1 className="text-white">Reset Password</h1>

                      <div className="accountCard">
                        <div className="mb-2">
                          <InputGroup>
                            <Field
                              id="email"
                              name="email"
                              value={values.email}
                              className="form-control"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              placeholder="E-mail*"
                              icons={email}
                              autoComplete="off"
                            />
                            <InputGroup.Text>
                              <i className="fa-regular fa-fw fa-envelope" />
                            </InputGroup.Text>
                          </InputGroup>
                          {touched.email && errors.email && <div className="errorMessage">{errors.email}</div>}
                        </div>
                        <div className="my-2">
                          <InputGroup>
                            <Field
                              id="new_password*"
                              name="password"
                              className="form-control"
                              value={values.password}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              placeholder="Enter New Password*"
                              icons={!state.show_pass ? eye_visible : eye_Invisible}
                              type={state.show_pass ? "text" : "password"}
                              autoComplete="off"
                              maxLength={25}
                            />
                            <InputGroup.Text
                              className="cursor-pointer"
                              onClick={() =>
                                setState({
                                  ...state,
                                  show_pass: !state.show_pass,
                                })
                              }
                            >
                              <i className={`fa-regular fa-fw ${state.show_pass ? "fa-eye-slash" : "fa-eye"}`} />
                            </InputGroup.Text>
                          </InputGroup>
                          {touched.password && errors.password && <div className="errorMessage">{errors.password}</div>}
                        </div>
                        <div className="mt-2">
                          <InputGroup>
                            <Field
                              id="reEnter_password"
                              name="reEnter_password"
                              className="form-control"
                              value={values.reEnter_password}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              placeholder="Re-enter New Password*"
                              icons={!state.con_pass ? eye_visible : eye_Invisible}
                              type={state.con_pass ? "text" : "password"}
                              maxLength={25}
                            />
                            <InputGroup.Text
                              className="cursor-pointer"
                              onClick={() =>
                                setState({
                                  ...state,
                                  con_pass: !state.con_pass,
                                })
                              }
                            >
                              <i className={`fa-regular fa-fw ${state.con_pass ? "fa-eye-slash" : "fa-eye"}`} />
                            </InputGroup.Text>
                          </InputGroup>
                          {touched.reEnter_password && errors.reEnter_password && <div className="errorMessage">{errors.reEnter_password}</div>}
                        </div>
                      </div>

                      <div className="d-flex justify-content-between align-items-center">
                        <CustomButton type="submit" variant="insurance" gradient>
                          Change Password
                        </CustomButton>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </Col>
          </Row>
        </Container>
      </div>
      <FooterBottom />
    </>
  );
}

export default connect(null, { resetPasswordAction })(withRouter(ResetPassword));
